import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

const apiClient: AxiosInstance =
  axios.create({
    baseURL:
      "https://api.themarstech.com/api",

    headers: {
      "Content-Type":
        "application/json",
    },

    timeout: 15000,
  });

apiClient.interceptors.request.use(
  (
    config:
      InternalAxiosRequestConfig
  ) => {
    try {
      const authToken =
        window.sessionStorage.getItem(
          "authToken"
        );

      const requestPath =
        String(
          config.url || ""
        ).split("?")[0];

      const isTableUserRequest =
        requestPath === "/table-user";

      const isTableLookupRequest =
        /^\/(table|branch)\/find\//.test(requestPath);

      delete config.headers.Authorization;

      if (
        authToken &&
        !isTableUserRequest &&
        !isTableLookupRequest
      ) {
        if (
          config.data instanceof FormData
        ) {
          config.data.set(
            "token",
            authToken
          );
        } else {
          config.data = {
            ...(config.data || {}),
            token: authToken,
          };
        }
      }
    } catch {
      
    }

    return config;
  },

  (error: AxiosError) =>
    Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) =>
    response,

  (error: AxiosError) => {
    if (
      error.response?.status === 401
    ) {
      console.warn(
        "API Unauthorized (401):",
        error.config?.url
      );
    } else {
      console.error(
        "API Error:",
        error.response?.status ||
        error.message,
        error.config?.url
      );
    }

    return Promise.reject(error);
  }
);

export default apiClient;